import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import {
  AppHeader,
  AppParagraph,
  AppFlexContainer,
  AppFlexItem,
} from 'client/ui-building-blocks'

import { formatNumber } from 'client/helpers'

type Props = {
  stats: {
    count: {
      users: number
      questions: number
      answers: number
    }
  }
}

const Stat = ({ count, label }: { count: string; label: string }) => {
  return (
    <div>
      <AppHeader text={count} size="xxlarge" centered />
      <AppParagraph text={label} centered />
    </div>
  )
}

const Stats = ({ stats }: Props) => {
  const { t } = useTranslation()

  return useMemo(() => {
    const data = [
      {
        countNum: stats.count.users,
        count: formatNumber(stats.count.users),
        label: t('homePage.stats.user', { count: stats.count.users }),
      },
      {
        countNum: stats.count.questions,
        count: formatNumber(stats.count.questions),
        label: t('homePage.stats.question', { count: stats.count.questions }),
      },
      {
        countNum: stats.count.answers,
        count: formatNumber(stats.count.answers),
        label: t('homePage.stats.answer', { count: stats.count.answers }),
      },
    ]

    return (
      <div data-testid="home-stats">
        <AppFlexContainer justifyContent="center" columnGap="50px" rowGap="25px">
          {data.map(({ count, label }, i) => (
            <AppFlexItem key={i}>
              <Stat count={count} label={label} />
            </AppFlexItem>
          ))}
        </AppFlexContainer>
      </div>
    )
  }, [stats, t])
}

Stats.defaultProps = {
  stats: {
    count: {
      users: 0,
      questions: 0,
      answers: 0,
    },
  },
}

export default Stats
